<!-- admin-portal-account.component.html -->
<div class="w-full h-full">

  <!-- ── Top bar ─────────────────────────────────────────────────────────── -->
  <div class="px-5 pt-5 pb-3 flex items-center justify-between mb-2">

    <!-- Left: create button -->
    <div class="flex items-center gap-4">
      <button
        appDisableWithoutPermission="admin.manage"
        matTooltip
        matTooltipClass="custom-orange-tooltip"
        matTooltipPosition="right"
        (click)="openCreateDialog()"
        class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-5 py-3"
      >
        Create Account
      </button>
    </div>

    <!-- Right: search -->
    <div class="flex items-center gap-2">
      <app-table-controls
        [showLimitControl]="false"
        [showSearchControl]="true"
        searchPlaceholder="Username, email, name…"
        (searchKeyupEvent)="onSearchKeyup($event)"
      ></app-table-controls>
    </div>

  </div>

  <!-- ── Data Table ──────────────────────────────────────────────────────── -->
  <div class="px-5">
    <div class="bg-light-orange" style="border-left: 1px solid #CAC2BC; border-right: 1px solid #CAC2BC;">

      <app-data-table
        [tableSubHeader]="tableSubHeader"
        [isLoading]="isLoading"
        [centeredContent]="true"
        [sort_type]="sort_type"
        (toggleOnSort)="sortList($event.key, $event.type)"
      >

        <!-- ── Rows ── -->
        <tr *ngFor="let user of userList" class="focus:outline-none">

          <!-- Username -->
          <td class="text-center text-xs">{{ user.username | nullWithDefault }}</td>

          <!-- Full Name -->
          <td class="text-center text-xs">{{ user.firstName }} {{ user.lastName }}</td>

          <!-- Email -->
          <td class="text-center text-xs">{{ user.email | nullWithDefault }}</td>

          <!-- Account Type -->
          <td class="text-center text-xs">
            {{ user.accountType | nullWithDefault }}
          </td>

          <!-- Date Created -->
          <td class="text-center text-xs">{{ user.dateCreated | asiaDate | nullWithDefault }}</td>

          <!-- Last Login -->
          <td class="text-center text-xs">{{ user.loginTime | asiaDate | nullWithDefault }}</td>

          <!-- Modified Date -->
          <td class="text-center text-xs">{{ user.dateModified | asiaDate | nullWithDefault }}</td>

          <!-- Modified By -->
          <td class="text-center text-xs">{{ user.modifiedBy | nullWithDefault }}</td>

          <!-- Status -->
          <td class="text-center text-xs">
            {{ getStatusLabel(user) }}
          </td>

          <!-- ── Actions ───────────────────────────────────────────────── -->
          <td class="text-center">
            <div class="flex items-center justify-center gap-1">

              <!-- ══════════════════════════════════════════════════════
                  ADMIN VIEW (Super Admin / Admin — Operations excluded via 'admin.manage' deny list)
                  - Edit: enabled only for non-admin account types
                  - Toggle Enable/Disable: visible and usable for all rows
                  ══════════════════════════════════════════════════════ -->
              <ng-container *ngIf="canViewAdminActions; else nonAdminActions">

                <!-- Edit: disabled for Admin / Super Admin rows -->
                <span
                  [matTooltip]="(canEditAccounts && isAdminAccount(user)) ? 'Admin accounts cannot be edited.' : ''"
                  [matTooltipDisabled]="!canEditAccounts || !isAdminAccount(user)"
                  matTooltipPosition="left"
                  matTooltipClass="custom-orange-tooltip"
                  [style.cursor]="isAdminAccount(user) ? 'not-allowed' : 'pointer'"
                  style="display: inline-block;"
                >
                  <button
                    appDisableWithoutPermission="admin.manage"
                    matTooltip
                    matTooltipClass="custom-orange-tooltip"
                    [disabled]="isAdminAccount(user)"
                    class="custom-btn focus:outline-none"
                    style="width:54px; height:23px; border-radius:5px; color:#fff;
                          background:#3374b7; font-size:10px; font-weight:600;"
                    [style.opacity]="(isAdminAccount(user) || !canEditAccounts) ? '0.4' : '1'"
                    [style.pointer-events]="isAdminAccount(user) ? 'none' : 'auto'"
                    (click)="openEditDialog(user)"
                  >
                    Edit
                  </button>
                </span>

                <!-- status === 0 → Enabled (green) -->
                <span
                  *ngIf="user.status === 0"
                  [style.cursor]="togglingUid === user.uid ? 'not-allowed' : 'pointer'"
                  style="display: inline-block;"
                >
                  <button
                    appDisableWithoutPermission="admin.manage"
                    matTooltip
                    matTooltipClass="custom-orange-tooltip"
                    class="custom-btn power-btn2 active focus:outline-none"
                    [class.disabled]="togglingUid === user.uid"
                    style="width:68px; height:23px; font-size:10px;"
                    [style.pointer-events]="togglingUid === user.uid ? 'none' : 'auto'"
                    [disabled]="togglingUid === user.uid"
                    (click)="toggleStatusConfirmation(user)"
                  >
                    <ng-container *ngIf="togglingUid === user.uid; else enabledLabel">…</ng-container>
                    <ng-template #enabledLabel>Enabled</ng-template>
                  </button>
                </span>

                <!-- status === 1 → Disabled (red) -->
                <span
                  *ngIf="user.status === 1"
                  [style.cursor]="togglingUid === user.uid ? 'not-allowed' : 'pointer'"
                  style="display: inline-block;"
                >
                  <button
                    appDisableWithoutPermission="admin.manage"
                    matTooltip
                    matTooltipClass="custom-orange-tooltip"
                    class="custom-btn power-btn2 focus:outline-none"
                    [class.disabled]="togglingUid === user.uid"
                    style="width:68px; height:23px; font-size:10px;"
                    [style.pointer-events]="togglingUid === user.uid ? 'none' : 'auto'"
                    [disabled]="togglingUid === user.uid"
                    (click)="toggleStatusConfirmation(user)"
                  >
                    <ng-container *ngIf="togglingUid === user.uid; else disabledLabel">…</ng-container>
                    <ng-template #disabledLabel>Disabled</ng-template>
                  </button>
                </span>

              </ng-container>

              <!-- ══════════════════════════════════════════════════════
                    NON-ADMIN VIEW (Operations, Audit, Marketing, Accounting)
                    - Edit button only, no toggle shown
                    - Only current user's own row is enabled
              ══════════════════════════════════════════════════════ -->
              <ng-template #nonAdminActions>
                <span
                  [matTooltip]="user.uid !== currentUserUid ? 'Only admins can edit other accounts.' : ''"
                  [matTooltipDisabled]="user.uid === currentUserUid || editSelfPerm.isDisabled"
                  matTooltipPosition="left"
                  matTooltipClass="custom-orange-tooltip"
                  [style.cursor]="(user.uid !== currentUserUid || editSelfPerm.isDisabled) ? 'not-allowed' : 'pointer'"
                  style="display: inline-block;"
                >
                  <button
                    #editSelfPerm="appDisableWithoutPermission"
                    appDisableWithoutPermission="admin.manage"
                    matTooltip
                    matTooltipClass="custom-orange-tooltip"
                    [disabled]="user.uid !== currentUserUid"
                    class="custom-btn focus:outline-none"
                    style="width:54px; height:23px; border-radius:5px; color:#fff;
                          background:#3374b7; font-size:10px; font-weight:600;"
                    [style.opacity]="(user.uid !== currentUserUid || editSelfPerm.isDisabled) ? '0.4' : '1'"
                    [style.pointer-events]="user.uid !== currentUserUid ? 'none' : 'auto'"
                    (click)="openEditDialog(user)"
                  >
                    Edit
                  </button>
                </span>
              </ng-template>

            </div>
          </td>

        </tr>

        <!-- ── Empty state ── -->
        <tr *ngIf="!isLoading && userList.length === 0">
          <td [attr.colspan]="tableSubHeader.length"
              class="text-center py-4 h-250-px text-gray-500 italic text-xs">
            No portal accounts found.
          </td>
        </tr>

      </app-data-table>
    </div><!-- /table wrapper -->
  </div>

  <!-- ── Footer: count + pagination ──────────────────────────────────────── -->
  <div class="px-5 py-3 flex align-items-center justify-between">

    <span class="text-xs font-semibold" style="color: #E07B39;">
      {{ showingText }}
    </span>

    <app-pagination
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      [pageSize]="pageSize"
      [totalItems]="totalItems"
      [showTotalEntries]="false"
      [removePadding]="true"
      backgroundColor="bg-white"
      (pageChange)="goToPage($event)"
      (previousPage)="goToPage(currentPage - 1)"
      (nextPage)="goToPage(currentPage + 1)"
    ></app-pagination>

  </div>
</div>

<ngx-spinner type="border" size="medium">
  <app-megapay-loader></app-megapay-loader>
</ngx-spinner>